export const APP_ENV = process.env.REACT_APP_ENV;
export const API_URL = process.env.REACT_APP_API_URL;
export const REACT_APP_OAUT_GOOGLE_SIGNUP_URL = process.env.REACT_APP_OAUT_GOOGLE_SIGNUP_URL;
export const LANDING_PAGES_DOMAIN = process.env.REACT_APP_LANDING_PAGES_DOMAIN;
export const LANDING_PAGE_URL = `https://${LANDING_PAGES_DOMAIN}`;
export const CDN_URL = process.env.REACT_APP_CDN_URL;
export const PIXEL_URL = process.env.REACT_APP_PIXEL_URL;
export const MEETINGS_BACK_URL = process.env.REACT_APP_MEETINGS_BACKEND_URL;
export const MEETINGS_AI_BACK_URL = process.env.REACT_APP_MEETINGS_AI_API_URL;
export const MEETINGS_AI_SOCKET_BASE_URL = process.env.REACT_APP_MEETINGS_AI_SOCKET_URL;
export const MEETINGS_PUBLIC_URL = process.env.REACT_APP_MEETINGS_PUBLIC_URL;
export const FORMS_PUBLIC_URL = process.env.REACT_APP_FORMS_PUBLIC_URL;

// SENTRY CONFIG
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_AUTH_TOKEN = process.env.SENTRY_AUTH_TOKEN;
export const VITE_COMMIT_SHA = process.env.VITE_COMMIT_SHA;
export const SENTRY_RELEASE = `${APP_ENV}-${VITE_COMMIT_SHA}`;
// Off until the A2P 10DLC campaign is approved: until then US carriers drop our texts (Twilio 30034).
export const SMS_SENDING_ENABLED = false;
